import {SamoobslugaStanInterface} from './types/samoobsluga-stan.interface'

export const samoobslugaStanPoczatkowy: SamoobslugaStanInterface = {
  correlationId: '',
  nrSzkody: '',
  token: '',
  stanSamoobslugi: '',
  tenant: '',
  linkAnkieta: ''
}
